<div mat-dialog-content>
  <div class="text-center">
    <h1 style="font-size: medium; font-weight: bold">Edit Book</h1>
  </div>

  <form class="form" [formGroup]="BookForm" (ngSubmit)="save()">
    <div class="form-row">
      <div class="col form-group">
        <label style="margin-top: 20px">Book Name :</label>
        <input style="width: 90%" formControlName="bookname" type="text" class="form-control" placeholder="" />
      </div>
      <div class="col form-group">
        <label style="margin-top: 20px">Author Name :</label>
        <input style="width: 90%" formControlName="authorname" type="text" class="form-control" placeholder="" />
      </div>
      <!-- form-group end.// -->

      <div class="col form-group">
        <label style="margin-top: 20px">Book Description :</label>
        <textarea style="width: 100%; margin-right: 10px; height: 42px;" formControlName="bookdesc" type="text" class="form-control"
          placeholder="">
        </textarea>
      </div>
    </div>

    <div class="form-row">
      <div class="col form-group">
        <label style="margin-top: -10px">Prakashan Name :</label>
        <input style="width: 90%" formControlName="prakashanname" type="text" class="form-control" placeholder="" />
      </div>
      <div class="col form-group">
        <label style="margin-top: -10px">Book Language :</label>
        <input style="width: 90%" formControlName="booklang" type="text" class="form-control" placeholder="" />
      </div>
      <!-- form-group end.// -->

      <div class="col form-group">
        <label style="margin-top: -10px">Book Publish Year : </label>
        <input style="width: 100%" formControlName="bookyear" type="date" class="form-control" />
      </div>
    </div>
    <!-- <div class="form-row">
      <div class="col form-group">
        <label style="margin-top: -10px">Book Price :</label>
        <input style="width: 90%" formControlName="price" type="text" class="form-control" placeholder="" />
      </div>
     

      <div class="col form-group">
        <label style="margin-top: -10px;">Book Sale Price : </label>
        <input style="width: 90%" formControlName="saleprice" type="text" class="form-control" />
      </div>


    <div class="col form-group">
      <label style="margin-top: -10px">Agent price :</label>
      <input style="width: 90%" type="text" formControlName="agentprice" />
    </div>

      <div class="col form-group">
        <label style="margin-top: -10px">Year :</label>
        <input style="width: 90%" formControlName="yearwisebook" type="text" class="form-control" placeholder="" />
      </div>


    </div> -->
<div class="form-row">
  <div class="col form-group">
    <label style="margin-top: -10px;">Book Price :</label>
    <input type="text" formControlName="price" class="form-control" />
  </div>

  <div class="col form-group">
    <label style="margin-top: -10px;">Book Sale Price :</label>
    <input type="text" formControlName="saleprice" class="form-control" />
  </div>

  <div class="col form-group">
    <label style="margin-top: -10px;">Agent Price :</label>
    <input type="text" formControlName="agentprice" class="form-control" />
  </div>

  <div class="col form-group">
    <label style="margin-top: -10px;">Year :</label>
    <input type="text" formControlName="yearwisebook" class="form-control" />
  </div>
</div>

    <div class="label">
        <label>Book Pages :</label>

    </div>
<div class="form-row">

  <div class="col-md-2 form-group mb-0">
    <mat-form-field class="example-full-width" appearance="outline" style="width: 100%; margin-top: 10px;">
      <mat-label>B/w</mat-label>
      <input  (change)="caltotalpages($event)" matInput type="number" formControlName="bookpagesbw" />
    </mat-form-field>
  </div>

  <div class="col-md-2 form-group mb-0">
    <mat-form-field class="example-full-width" appearance="outline" style="width: 100%; margin-top: 10px">
      <mat-label>Inside Color</mat-label>
      <input (change)="caltotalpages($event)" matInput type="number" formControlName="bkpinsidecolor" />
    </mat-form-field>
  </div>

  <div class="col-md-2 form-group mb-0">
    <mat-form-field class="example-full-width" appearance="outline" style="width: 100%; margin-top: 10px">
      <mat-label>Cover</mat-label>
      <input (change)="caltotalpages($event)" matInput type="number" formControlName="bkpcover" />
    </mat-form-field>
  </div>

  <div class="col-md-2 form-group mb-0">
    <mat-form-field class="example-full-width" appearance="outline" style="width: 100%; margin-top: 10px">
      <mat-label>Total Pages</mat-label>
      <input matInput type="number" formControlName="totalpages" readonly />
    </mat-form-field>
  </div>

  <div class="col-md-4 form-group mb-0">
    <mat-form-field class="example-full-width" appearance="outline" style="width: 100%; margin-top: 10px">
      <mat-label>Binding</mat-label>
      <input matInput type="text" formControlName="binding" />
    </mat-form-field>
  </div>
</div>

  <div class="label">
        <label>Paper :</label>
  </div>

  <div class="form-row">
    <div class="col-md-2 form-group mb-0">
     <mat-form-field class="example-full-width" appearance="outline" 
          style="width: 100%; margin-top: 0px">
          <mat-label>B/w</mat-label>
          <input matInput type="text" formControlName="paperbw" />
        </mat-form-field>
    </div>
     <div class="col-md-2 form-group mb-0">
      <mat-form-field class="example-full-width" appearance="outline"
            style="width: 100%; margin-top: 0px">
            <mat-label>Insie color</mat-label>
            <input matInput type="text" formControlName="paperinsidecolor" />
          </mat-form-field>
     </div>
     <div class="col-md-2 form-group mb-0">
      <mat-form-field class="example-full-width" appearance="outline"
           style="width: 100%; margin-top: 0px">
          <mat-label>Cover</mat-label>
          <input matInput type="text" formControlName="papercover" />
        </mat-form-field>
     </div>
     <div class="col-md-2 form-group mb-0">
     </div>
     <div class="col-md-4 form-group mb-0">
       <mat-form-field class="example-full-width" appearance="outline"
          style="width: 100%; margin-top: 0px">
          <mat-label>Book Size</mat-label>
          <input matInput type="text" formControlName="booksize" />
        </mat-form-field>
     </div>

  </div>

   
  
    

    <div class="form-row">
      <div class="col form-group">
        <label style="margin-top: -10px">Book Category : </label>
        <input style="width: 90%" formControlName="bookcategory" type="text" class="form-control" />
      </div>

      <div class="col form-group">
        <label style="margin-top: -10px">Print Copies :</label>
        <input style="width: 90%" formControlName="bookedtncpoies" type="text" class="form-control" placeholder="" />
      </div>

      <div class="col form-group">
        <label style="margin-top: -10px">Opening Stock :</label>
        <input style="width: 90%" formControlName="opening_stock" type="text" class="form-control" placeholder="" />
      </div>
    </div>

    <div class="form-row">
      <div class="col-md-4 form-group">
        <label style="margin-top: -10px">Book Edition :</label>
        <input style="width: 90%" formControlName="bookedition" type="text" class="form-control" placeholder="" />
      </div>
      <!-- form-group end.// -->

      <div class="col-md-4 form-group">
        <label style="margin-top: -10px">Date : </label>
        <input style="width: 90%" formControlName="bookedtndate" type="date" class="form-control" />
      </div>


      <div class="col-md-4 form-group">
        <label style="margin-top: -10px">लेखक मानधन : </label>
        <input style="width: 100%" formControlName="author_honorarium" type="text" class="form-control" />
      </div>
      <!-- <div class="col form-group">
        <label style="margin-top: 10px">Copies :</label>
        <input style="width: 90%" formControlName="bookedtncpoies" type="text" class="form-control" placeholder="" />
      </div> -->
    </div>

       <div class="form-row">
      
    </div>

    <!-- <div class="col form-group">
        <label style="margin-top: 10px">is Deliver charges included in Price : </label>
        <select style="width: 100%" class="form-control" placeholder="Select One" formControlName="isdelivery">
          <option value="Y">Yes</option>
          <option value="N">No</option>
        </select>
      </div> -->


    <div class="form-row">
      <div class="col-md-6 form-group">
        <label>Publish Status : </label>
        <select style="width: 60%" class="form-control" placeholder="Select One" formControlName="isupcoming"
          (change)="getSearchTerm($event)">
          <option value="N">Publish Now</option>
          <option value="Y">Upcomming</option>
        </select>
      </div>
      <!-- form-group end.// -->

      <div class="col-md-6 form-group" *ngIf="isupcoming">
        <label>Upcomming Book Date : </label>
        <input style="width: 61%" formControlName="upcomingdate" type="date" class="form-control" />
      </div>
      <!-- form-group end.// -->
      <!-- </div> -->
    </div>

   <div class="form-row">
  <!-- Image Preview Column -->
  <div class="col-md-6 form-group">
    <label>Uploaded Book Image:</label><br />
    <img [src]="bookimgpath" width="100" alt="Book Image" />
  </div>

  <!-- Upload Input Column -->
  <div class="col-md-6 form-group">
    <label>Upload Book Image:</label>
    <input 
      type="file"
      name="file"
      class="form-control"
      (change)="ImageUploads($event)"
      [uploader]="uploader"
      ng2FileSelect
    />
  </div>
</div>


    <div mat-dialog-actions style="float: right;margin-top: 60px;">
      <button mat-button mat-dialog-close>Close</button>
      <button [disabled]="BookForm.invalid" mat-button class="btn btn-info" type="submit">
        Update
      </button>
    </div>
    <!-- form-group// -->
  </form>
</div>